<template>
  <div class="chat-question-component">
    <div class="content">{{ content }}</div>
    <template v-if="index === 'questionA' || index === 'questionC'">
      <div class="options"
           :class="{
              'options-img-a': index === 'questionA',
              'options-img-c': index === 'questionC'
             }"
      >
        <div class="option"
             v-for="(item, i) in optionList"
             :key="index + i"
             @click="handleOptionClick(item.score, i)"
        >
          <img :src="item.img" alt="">
          <div class="option-block-box desc">
            {{ item.desc }}
          </div>
        </div>
        <chat-right class="chat-right"
                    :content="result"
                    v-if="result !== ''"
        />
      </div>
    </template>
    <template v-if="index === 'questionB' || index === 'questionE' || index === 'questionF'">
      <div class="options"
           :class="{
              'options-text-b': index === 'questionB',
              'options-text-e': index === 'questionE',
              'options-text-f': index === 'questionF',
             }"
      >
        <div class="option"
             v-for="(item, i) in optionList"
             :key="i"
             @click="handleOptionClick(item.score, i)"
        >
          <div class="option-white-box desc"
               v-if="index === 'questionF'"
               v-ym-report:MARKETING_LIUXUAN_TEST_FINISH
          >
            {{ item.desc }}
          </div>
          <div class="option-white-box desc"
               v-else
          >
            {{ item.desc }}
          </div>
        </div>
        <chat-right class="chat-right"
                    :content="result"
                    v-if="result !== ''"
        />
      </div>
    </template>
    <template v-if="index === 'questionD'">
      <div class="slide-list"
           :class="[`active${currIndex}`]"
      >
        <div class="slide-item"
             v-for="(item, i) in options"
             :key="i"
             @click="handleSlideClick(item.desc, item.score, i)"
        >
          {{ item.desc }}
          <img class="circle-icon"
               :src="require('@/pages/2019/LiuXuanTest/assets/img/circle.png')"
               alt=""
               v-if="currIndex === i"
          >
        </div>
      </div>
      <div class="slide-hint">Tips: 点击选择 拖延等级</div>
      <chat-right class="chat-right"
                  :content="result"
                  v-if="result !== ''"
      />
    </template>
    <audio ref="clickVoice"
           :src="require('@/pages/2019/LiuXuanTest/assets/click-voice.mp3')"
           preload="auto"
    ></audio>
    <audio ref="questionBVoice"
           :src="require('@/pages/2019/LiuXuanTest/assets/question-b-voice.mp3')"
           preload="auto"
    ></audio>
    <audio ref="questionEVoice"
           :src="require('@/pages/2019/LiuXuanTest/assets/question-e-voice.mp3')"
           preload="auto"
    ></audio>
  </div>
</template>

<script>
  import ChatRight from '@/pages/2019/LiuXuanTest/components/ChatRight';

  export default {
    name: 'ChatQuestion2019',
    components: {
      ChatRight,
    },
    props: {
      content: {
        type: String,
        required: true,
      },
      options: {
        type: Array,
      },
      index: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        disabled: false,
        result: '',
        currIndex: -1,
        optionList: [],
      };
    },
    methods: {
      handleOptionClick(score, index) {
        if (this.disabled) return;
        this.disabled = true;
        this.$refs.clickVoice.play();
        if (this.index === 'questionB') {
          this.$refs.questionBVoice.play();
        }
        if (this.index === 'questionE') {
          this.$refs.questionEVoice.play();
        }
        this.$emit('score', score);
        setTimeout(() => {
          this.$emit('addShowBlockCount');
        }, 1000);
        this.optionList[index].selected = true;
        if (index === 0) {
          this.result = 'A';
          return;
        }
        if (index === 1) {
          this.result = 'B';
          return;
        }
        this.result = 'C';
      },
      handleSlideClick(desc, score, i) {
        if (this.disabled) return;
        this.disabled = true;
        this.$refs.clickVoice.play();
        this.currIndex = i;
        if (this.index === 'questionB') {
          this.$refs.questionBVoice.play();
        }
        if (this.index === 'questionE') {
          this.$refs.questionEVoice.play();
        }
        this.$emit('score', score);
        setTimeout(() => {
          this.$emit('addShowBlockCount');
        }, 1000);
        this.result = `拖延${desc}级`;
      },
      fetchOptions() {
        return this.options.map((item) => {
          item.selected = false;
          return item;
        });
      },
    },
    created() {
      this.$nextTick(() => {
        document.getElementById('page-end').scrollIntoView();
      });
      this.optionList = this.fetchOptions();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .option-block-box {
    max-width: 100%;
    box-sizing: border-box;
    border-radius: 28px;
    background: #333;
    color: @color-white;
    font-size: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .option-white-box {
    width: 558px;
    height: 70px;
    margin: 0 auto;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background: @color-white;
    box-shadow: 0 2px 15px 0 rgba(71, 159, 157, 0.3);
    border-radius: 35px;
    color: #333;
    font-size: 26px;
  }

  .chat-question-component {
    padding-bottom: 80px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .content {
    width: 630px;
    margin-bottom: @size-medium;
    padding: 25px @size-base;
    box-sizing: border-box;
    font-size: 26px;
    background: #36aba8;
    color: @color-white;
    border-radius: @border-radius-medium / 2;
  }

  .options {
    display: flex;
    flex-wrap: wrap;
  }

  .option {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img {
      display: block;
      margin-bottom: @size-extra-small / 2;
    }
  }

  .options-img-a {
    .option {
      height: 316px;
      justify-content: flex-end;
      .desc {
        width: 280px;
        height: 110px;
        border-radius: 56px;
        padding: 0 35px;
      }
      &:nth-child(1) {
        width: 100%;
        height: 260px;
        margin-bottom: @size-base;
        img {
          display: block;
          width: 88px;
        }
      }
      &:nth-child(2) {
        width: 50%;
        img {
          display: block;
          width: 64px;
          height: 196px;
        }
      }
      &:nth-child(3) {
        width: 50%;
        img {
          display: block;
          width: 200px;
          height: 178px;
        }
      }
    }
  }

  .options-img-c {
    .option {
      height: 234px;
      justify-content: flex-end;
      .desc {
        width: 280px;
        height: 54px;
        border-radius: 27px;
      }
      &:nth-child(1) {
        width: 100%;
        margin-bottom: @size-base;
        img {
          width: 206px;
          height: 170px;
        }
      }
      &:nth-child(2) {
        width: 50%;
        img {
          width: 140px;
          height: 164px;
        }
      }
      &:nth-child(3) {
        width: 50%;
        img {
          width: 114px;
          height: 160px;
        }
      }
    }
  }

  .options-text-b,
  .options-text-e,
  .options-text-f {
    width: 100%;
    height: 422px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 12px;
    background: url('~@/pages/2019/LiuXuanTest/assets/img/fish.gif') no-repeat;
    background-size: 100% 422px;
    .option {
      &:nth-child(1), &:nth-child(2) {
        margin-bottom: 26px;
      }
    }
    .desc {
      padding-left: 95px;
    }
  }

  .options-text-e {
    height: 384px;
    background: none;
    position: relative;
    .option {
      z-index: @z-index-large;
    }
    &:before {
      content: '';
      width: 206px;
      height: 250px;
      display: block;
      position: absolute;
      left: 0;
      bottom: 52px;
      background: url('~@/pages/2019/LiuXuanTest/assets/img/lamp.png') no-repeat;
      background-size: contain;
      z-index: @z-index-medium;
    }
    &:after {
      content: '';
      width: 212px;
      height: 324px;
      display: block;
      position: absolute;
      right: 0;
      bottom: 36px;
      background: url('~@/pages/2019/LiuXuanTest/assets/img/faucet.png') no-repeat;
      background-size: contain;
      z-index: @z-index-medium;
    }
  }
  .options-text-f {
    height: auto;
    background: none;
  }

  .slide-list {
    margin: @size-large auto 0;
    width: 550px;
    height: 35px;
    display: flex;
    align-items: center;
    position: relative;
    &:before {
      content: '';
      width: 64px;
      height: 60px;
      background: url('~@/pages/2019/LiuXuanTest/assets/img/q4_op2.png') no-repeat;
      background-size: contain;
      position: absolute;
      left: -10px;
      top: -60px;
    }
    &:after {
      display: block;
      content: '';
      width: 88px;
      height: 32px;
      background: url('~@/pages/2019/LiuXuanTest/assets/img/q4_op1.png') no-repeat;
      background-size: contain;
      position: absolute;
      top: -32px;
    }
    &.active-1 {
      &:after {
        display: none;
      }
    }
    &.active4 {
      &:after {
        right: -26px;
      }
    }
    &.active1 {
      &:after {
        right: 334px;
      }
    }
    &.active2 {
      &:after {
        right: 224px;
      }
    }
    &.active3 {
      &:after {
        right: 114px;
      }
    }
  }
  .slide-hint {
    color: @color-text-lighter;
    font-size: 26px;
    margin-top: @size-small;
  }

  .slide-item {
    position: relative;
    z-index: 1;
    width: 110px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: @color-white;
    &:nth-child(1) {
      background: fade(#36aba8, 20%);
    }
    &:nth-child(2) {
      background: fade(#36aba8, 40%);
    }
    &:nth-child(3) {
      background: fade(#36aba8, 60%);
    }
    &:nth-child(4) {
      background: fade(#36aba8, 80%);
    }
    &:nth-child(5) {
      background: #36aba8;
    }
    .circle-icon {
      position: absolute;
      z-index: 2;
      left: @size-base;
      top: -@size-extra-small;
      width: 52px;
      height: 52px;
      display: block;
    }
  }

  .chat-right {
    margin-top: @size-extra-medium;
  }

</style>
